import React, { Component } from 'react';
import '@atlaskit/css-reset';
// eslint-disable-next-line jira/restricted/styled-components, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { ThemeProvider } from 'styled-components';
import { ErrorBoundaryFlag as ErrorBoundary } from '@atlassian/jira-error-boundary-flag-renderer';
import { ProjectContextProvider } from '@atlassian/jira-providers-project-context';
import { withRouter, type RouteContext } from '@atlassian/jira-router';
import { ProjectSettingsController } from '@atlassian/jira-spa-apps-project-settings-common/src/components/routing-filter';
import { TenantContextSubscriber } from '@atlassian/jira-tenant-context-controller';
import JiraAutomation from './ui';

type Props = RouteContext;

const METRICS_PAGE_ID = 'project-settings-apps.jira-automation';

// eslint-disable-next-line jira/react/no-class-components
export class JiraAutomationSettingsPage extends Component<Props> {
	renderContents = () => (
		<ErrorBoundary id={METRICS_PAGE_ID}>
			<TenantContextSubscriber>
				{({ tenantContext }) => (
					<ProjectContextProvider>
						{(projectContext) => (
							<>
								<ThemeProvider theme={{}}>
									<JiraAutomation
										tenantContext={tenantContext}
										projectContext={projectContext.data}
									/>
								</ThemeProvider>
							</>
						)}
					</ProjectContextProvider>
				)}
			</TenantContextSubscriber>
		</ErrorBoundary>
	);

	render() {
		const { projectKey } = this.props.match.params;
		return (
			<ProjectSettingsController projectKey={projectKey}>
				{this.renderContents()}
			</ProjectSettingsController>
		);
	}
}

export default withRouter(JiraAutomationSettingsPage);
